import { createTooltip } from "./tooltip-utils"

export default {
  mounted() {
    this._cleanup = createTooltip(this.el, (el) => `
      <div class="font-bold text-base-content mb-1">${el.dataset.name}</div>
      <span class="badge badge-sm badge-outline mb-2">${el.dataset.category}</span>
      <div class="text-base-content/80 leading-relaxed">${el.dataset.definition}</div>
    `, { width: "18rem" })
  },
  destroyed() {
    if (this._cleanup) this._cleanup()
  }
}
